import * as React from 'react';
import {useCallback, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Alert, IconButton, Input, Snackbar} from "@mui/material";
import {makeApiCall} from "../../hooks/CancellableApiCall";
import {UserResponse} from "../../data/UserResponse";
import {UserSelector} from "../UserSelector";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import {EventResponse} from "../../data/events/EventResponse";
import {AlertType} from "../../data/AlertType";
import useUser from "../../hooks/useUser";
import {EventAttendeeResponse} from "../../data/events/EventAttendeeResponse";

interface InviteAttendeeFormProps {
    event: EventResponse,
    eventAttendees: EventAttendeeResponse[],
    onSuccessfulInvite: (nick: string, communityId: string) => void
}

export default function InviteEventAttendeeForm(props: InviteAttendeeFormProps) {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("")
    const [user, setUser] = useState<UserResponse | null>(null)
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState<AlertType>("success")
    const [alertText, setAlertText] = useState("")
    const setAlert = useCallback((type: AlertType, text: string) => {
        setAlertType(type)
        setAlertText(text)
        setShowAlert(true)
    }, [setAlertType, setAlertText, setShowAlert])
    const self = useUser()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <IconButton size="small" color="info" onClick={handleClickOpen}>
                <ForwardToInboxIcon color={"info"} fontSize="small" />
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Invite User</DialogTitle>
                <DialogContent>
                    <UserSelector onUserSelected={setUser} user={user} extendedUserInformation={true}/>
                </DialogContent>
                <DialogContent>
                    <DialogContentText>
                        Invite Message (If blank no inbox will open)
                    </DialogContentText>
                    <Input multiline rows={3} placeholder={"Enter reason..."} size="small" sx={{width: 500}}
                           onChange={(event) => setMessage(event.target.value)}
                    ></Input>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button color={"info"} variant={"contained"} onClick={() => {
                        if (user?.communityId === self.user?.communityId) {
                            setAlert("error", "You cannot add yourself to a event that you can already access")
                            return
                        }
                        if (props.eventAttendees.find((a) => {return a.communityId === user?.communityId}) !== undefined) {
                            setAlert("error", "This user is already in this event")
                            return
                        }
                        makeApiCall({
                            url: `/api/event/invite/${user?.communityId}`,
                            method: "POST",
                            body: {
                                eventId: props.event.id,
                                message: message
                            },
                            onLoadedCallback: () => {
                                setOpen(false)
                                props.onSuccessfulInvite(user!!.nick, user!!.communityId)
                            },
                            onError: () => {}
                        })
                    }}>Invite</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={showAlert} autoHideDuration={5000} onClose={() => setShowAlert(false)}>
                <Alert severity={alertType} onClose={() => setShowAlert(false)} sx={{width: "100%"}} variant="filled">
                    {alertText}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}